<template>

    <div style="color: #666">

        <div style="margin: 1vw 0; ">
            <div class="pd-10" style="font-size: 26px;">{{ article.title }}</div>
            <!--<div class="pd-10" style="font-size: 26px;"><router-link :to="'/articleDetail?id=' + article.id">{{article.title }}</router-link></div>-->
            <div style="font-size: 16px; margin-top: 5px">
                <i class="el-icon-user-solid"></i> <span>{{ article.user }}</span>
                <i style="margin-left:1vw;" class="el-icon-view"></i>
                <span v-if="article.viewCount >=10000">{{(article.viewCount/10000).toFixed(2) }}万</span>
                <span v-else>{{ article.viewCount }}</span>
                <i class="el-icon-time" style="margin-left: 1vw"></i> <span>{{ article.createTime }}</span>
            </div>
        </div>
        <div>
            <div v-if="article.video === null || article.video === '' ">
                <div><router-link :to="'/articleDetail?id=' + article.id">
                    <img :src="article.picture" alt="" style="width:1000px; height: 562px"></router-link>
                </div>
            </div>
            <div v-else >
                <div style="display: flex; margin-top: 10px">
                    <div style="flex: 1"></div>
                    <div ><router-link :to="'/articleDetail?id=' + article.id">
                        <img :src="article.picture" alt="" style="width:480px; height: 270px"></router-link>
                    </div>
                    <div style="flex: 1"></div>
                </div>
                <div style="width:1000px; height: 562px">
                    <iframe :src="article.video"
                            scrolling="no"
                            border="0"
                            frameborder="no"
                            framespacing="0"
                            allowfullscreen
                            llowfullscreen="true" width="100%" height="100%"> </iframe>
                </div>

            </div>
        </div>
        <div style="margin: 1vw 0">
            <mavon-editor
                    class="md"
                    :value="article.content"
                    :subfield="false"
                    :defaultOpen="'preview'"
                    :toolbarsFlag="false"
                    :editable="false"
                    :scrollStyle="true"
                    :ishljs="true"
                    :external-link="externalLink"
            />
        </div>
        <div>
            <div v-if="article.description === '' || article.description === null">
                <div>
                    <el-divider>www.DashenAE.com</el-divider>
                </div>
            </div>
            <div v-else>
                <el-card style="background-color: #fbfbfb">
                    <div style="font-size: 22px; text-align:center" >
                        本期资源为<span style="color: red">VIP资源</span>，成为VIP用户即可免费下载！！
                    </div>
                    <div style="font-size: 22px; text-align:center; margin-top: 5px">
                        如果您还不是VIP用户，欢迎点击<span style="color: #40a9ff;" @click="$router.push('/join')">下方按钮</span>加入VIP！！
                    </div>
                    <div style="display: flex; margin-top: 10px">
                        <div style="flex: 1"></div>
                        <el-button type="primary" size="20px" @click="check">点击查看下载链接</el-button>
                        <div style="flex: 1"></div>
                    </div>
                </el-card>
                    <div class="show" v-show="show">
                        <el-card style="background-color: #fbfbfb; margin-top: 10px">
                            <div style="font-size: 32px; color: #141414">{{article.description}}</div>
                        </el-card>
                    </div>
            </div>
            <div style="margin-top: 10px;margin-bottom: 20px" @click="$router.push('/join')">
                <img src="../../assets/vip06.png">
            </div>
        </div>
        <div style="margin: 3vw 0">
            <div style="margin: 1vw 0">
                <div style="border-bottom: 1px solid orangered; padding: 10px 0; font-size: 20px">评论</div>
                <div style="padding: 10px 0">
                    <el-input size="small" placeholder="说点什么呢``" type="textarea" v-model="commentForm.content"></el-input>

                </div>
                <div class="pd-10" style="text-align: right">
                    <el-button type="primary" size="small" @click="save">评论</el-button>

                </div>
            </div>

<!--      评论列表-->
            <div>
                <div v-for="item in comments" :key="item.id" style="border-bottom: 1px solid #ccc; padding: 10px 0; ">
                    <div style="display: flex">
                        <div style="width: 100px; text-align: center">
                            <el-image :src="item.avatarUrl" style="width: 50px; height: 50px; border-radius: 10%"></el-image>
                        </div> <!--  头像-->
                        <div style="flex: 1; font-size: 14px; padding: 5px 0; line-height: 25px">
                            <b>{{ item.nickname }}：</b>
                            <span>{{ item.content }}</span>

                            <div style="display: flex; line-height: 20px; margin-top: 5px">
                                <div style="width: 200px;">
                                    <i class="el-icon-time"></i><span style="margin-left: 5px">{{ item.time }}</span>
                                </div>
                                <div style="text-align: right; flex: 1">
                                    <el-button style="margin-left: 5px" type="text" @click="handleReply(item.id)">回复</el-button>
                                    <el-button type="text" style="color: red" @click="del(item.id)" v-if="user.id === item.userId">删除</el-button>
                                </div>
                            </div>
                        </div>   <!--  内容-->
                    </div>

                    <div v-if="item.children.length"  style="padding-left: 100px;">
                        <div v-for="subItem in item.children" :key="subItem.id"  style="background-color: #f0f0f0; padding: 5px 20px">
                            <!--          回复列表-->
                            <div style="font-size: 14px; padding: 5px 0; line-height: 25px">
                                <div >
                                    <el-image :src="subItem.avatarUrl" style="width: 25px; height: 25px;margin-right:10px; border-radius: 25%"></el-image>
                                    <b>{{ subItem.nickname }}：</b>
                                        <b style="color: #3a8ee6" v-if="subItem.pnickname">@{{ subItem.pnickname }}</b>
                                    <span style="margin-left: 10px">{{ subItem.content }}</span>
                                </div>

                                <div style="display: flex; line-height: 20px; margin-top: 5px; padding-left: 5px">
                                    <div style="width: 200px;">
                                        <i class="el-icon-time"></i><span style="margin-left: 5px">{{ subItem.time }}</span>
                                    </div>
                                    <div style="text-align: right; flex: 1">
                                        <el-button style="margin-left: 5px" type="text" @click="handleReply(subItem.id)">回复</el-button>
                                        <el-button type="text" style="color: red" @click="del(subItem.id)" v-if="user.id === subItem.userId">删除</el-button>
                                    </div>
                                </div>
                            </div>   <!--  内容-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="回复" :visible.sync="dialogFormVisible" width="50%" >
            <el-form label-width="80px" size="small">
                <el-form-item label="回复内容">
                    <el-input type="textarea" v-model="commentForm.contentReply" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="save"  size="small">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    // import 'video.js/dist/video-js.css'
    // import { videoPlayer } from 'vue-video-player'

    export default {
        name: "ArticleDetail",
        components: {
            // videoPlayer
        },
        data() {
            return {
                externalLink: {
                    markdown_css: false,
                    hljs_js: () => '/md/highlightjs/highlight.min.js',
                    hljs_css: (css) => '/md/highlightjs/styles/' + css + '.min.css',
                    hljs_lang: (lang) => '/md/highlightjs/languages/' + lang + '.min.js',
                    katex_css: () => '/md/katex/katex.min.css',
                    katex_js: () => '/md/katex/katex.min.js',
                },
                article: {},
                user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
                comments: [],
                commentForm: {},
                id: this.$route.query.id,
                dialogFormVisible: false,

                // id: this.$route.query.id,
                // video: {},
                playerOptions: {
                    playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                    autoplay: false, // 如果为true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 是否视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    // flash: { hls: {withCredentials: false} }, // 可以使用rtmp视频
                    // html5: { hls: {withCredentials: false} }, // 可以使用m3u8视频
                    sources: [{
                        type: "video/mp4", // 类型
                        src: '' // url地址
                    }],
                    poster: '', // 封面地址
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true, // 是否显示全屏按钮
                        volumeControl: true, //声音控制键

                    }
                },
                currentTime: null,
                show:false,
            }
        },
        created() {
            this.load();
            // this.submit()
            this.loadComment();
            let id =  this.$route.query.id;
            this.request("/article/" + id).then(res => {
                // console.log(res.data)
                this.playerOptions.sources[0].src = res.data.video;
                this.playerOptions.poster = res.data.picture;
            })

        },
        methods: {
            async getUser() {
                return (await this.request.get("/user/username/" + this.user.username)).data
            },
            // 绑定@imgAdd event
            imgAdd: function (pos, $file) {
                let $vm = this.$refs.md;
                // 第一步.将图片上传到服务器.
                const formData = new FormData();
                formData.append('file', $file);
                axios({
                    url: 'http://' + serverIp + ':9090/file/upload',
                    method: 'post',
                    data: formData,
                    headers: {'Content-Type': 'multipart/form-data'},
                }).then((res) => {
                    // 第二步.将返回的url替换到文本原位置![...](./0) -> ![...](url)
                    $vm.$img2Url(pos, res.data);
                })
            },

            /* 获取视频播放进度 */
            onPlayerTimeupdate (player) {
                this.currentTime = player.cache_.currentTime
            },
            /* 设置视频开始的进度 */
            playerReadied (player) {
                player.currentTime(this.currentTime)
            },
            // 暂停回调   将视频播放的时间保存
            onPlayerPause(player) {
                console.log('player pause currentTime!', player.cache_.currentTime);
                let that = this;
                //TODO   存储player.currentTime 是当前暂停时间    用于下次断续播放

            },
            load() {
                this.request.get("/article/" + this.id).then(res => {
                    this.article = res.data;
                    this.article.viewCount = ++ res.data.viewCount;
                    //提交增加后的阅读量数据
                    this.submit();
                    // console.log(res.data.title)
                    // 修改标题
                    document.title = res.data.title

                })

                // 更新浏览器存储的用户信息
                this.getUser().then(res => {
                    res.token = JSON.parse(localStorage.getItem("user")).token
                    localStorage.setItem("user", JSON.stringify(res))
                })
            },
            // 增加阅读量
            submit() {
                this.request.post("/article", this.article).then(res => {
                    if (res.code === '200') {
                        // console.log("浏览量+1")
                    } else {
                        // this.$message.error("保存失败")
                    }
                })
            },
            loadComment() {
                this.request.get("/comment/tree/" + this.id).then(res => {
                    this.comments = res.data;
                })
            },
            save() {
                if (!this.user.id) {
                    this.$message.warning("请登录后操作!");
                    return
                }
                if(this.commentForm.content != null || this.commentForm.contentReply != null){
                    this.commentForm.articleId = this.id;
                    if (this.commentForm.contentReply) {
                        this.commentForm.content = this.commentForm.contentReply
                    }
                    this.request.post("/comment", this.commentForm).then(res => {
                        if (res.code === '200') {
                            this.$message.success('咻~~');
                            this.commentForm = {}; // 初始化评论对象内容
                            this.loadComment();
                            this.dialogFormVisible = false
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }else {
                    this.$message.warning("请输入评论！");
                    return
                }

            },
            check() {
                if (!this.user.id) {
                    this.$message.warning("您还没有登录哦，请登录后操作!");
                    return
                }
                if (this.user.role==='ROLE_USER'){
                    this.$message.error("您还不是VIP哦，请联系站长开通权限!");
                    return
                }
                else {
                    this.$message.success("VIP资源链接已显示！");
                    if(this.show = false){
                        this.show = !this.show;
                    }
                    if(this.show = true){
                        this.show = this.show;
                    }

                    return
                }
            },
            del(id) {
                this.request.delete("/comment/" + id).then(res => {
                    if (res.code === '200') {
                        this.$message.success("删除成功");
                        this.loadComment();
                    } else {
                        this.$message.error("删除失败")
                    }
                })
            },
            handleReply(pid) {
                this.commentForm = { pid: pid };
                this.dialogFormVisible = true
            },
            detail(id) {
                this.$router.push({path: "/videoDetail", query: {id: id}})
            },
        }
    }
</script>

<style>
    /*.course_node_video {*/
        /*width: 100%;*/
        /*height: auto;*/
        /*margin: 0 auto;*/
        /*text-align: center;*/
    /*}*/
    /*.course_node_video >>> .vjs-progress-control{*/
        /*pointer-events: none;*/
    /*}*/
    .headerBg {
        background: #eee!important;
    }
    /*a{*/
        /*text-decoration: none;*/
        /*!*color:#1c1b1b;*!*/
        /*color:#171c19;*/
        /*!*font-family:"阿里巴巴普惠体 Medium";*!*/
        /*!*font-family:sans-serif;*!*/

        /*font-size: 26px;*/
    /*}*/
</style>
